import {
  type Dropdown,
  type LeadsListListData,
  type PaginatedDropdownList,
  type ProductsListListData,
  InvoiceStatus,
  leadsListListInfiniteOptions,
  productsListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect, RangePickerFilter } from '@crm/components'
import {
  defaultFiltersMultipleValues,
  defaultFiltersNumberValues,
  getActiveFiltersCount
} from '@crm/utils'
import { MoreFiltersPopover } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { Select } from 'antd'

export const ReportsFilters = () => {
  const { t } = useLocales()
  const { params, updateQuery } = useQueryUpdate()

  const leadValue = defaultFiltersMultipleValues(params?.lead, true)
  const productValue = defaultFiltersNumberValues(params?.product)

  const billingStatusesOptions = Object.values(InvoiceStatus).map((status) => ({
    label: t(`billing.${status}`),
    value: status
  }))

  const countedFilters = ['created_at_from', 'pay_date_from', 'due_date_from']

  const onResetMoreFilters = () => {
    updateQuery({
      created_at_from: undefined,
      created_at_to: undefined,
      pay_date_from: undefined,
      pay_date_to: undefined,
      due_date_from: undefined,
      due_date_to: undefined
    })
  }

  return (
    <>
      <Select
        allowClear
        placeholder={t('billing.status')}
        value={params.status}
        onChange={(status) => updateQuery({ status })}
        className="select-min-width"
        mode="multiple"
        options={billingStatusesOptions}
      />

      <InfiniteSelect<LeadsListListData, PaginatedDropdownList, Dropdown>
        value={leadValue}
        className="select-min-width"
        popupMatchSelectWidth
        mode="multiple"
        placeholder={t('filter.leads')}
        getQueryFunction={leadsListListInfiniteOptions}
        onChange={(lead) => updateQuery({ lead })}
        baseOptions={{ query: { preference: params?.lead } }}
        maxTagCount={1}
        maxTagTextLength={6}
      />

      <InfiniteSelect<ProductsListListData, PaginatedDropdownList, Dropdown>
        value={productValue}
        className="select-min-width"
        popupMatchSelectWidth
        placeholder={t('contracts.product')}
        getQueryFunction={productsListListInfiniteOptions}
        onChange={(product) => updateQuery({ product })}
        baseOptions={{ query: { preference: params?.product } }}
      />

      <MoreFiltersPopover
        onResetMoreFilters={onResetMoreFilters}
        filterActiveCount={getActiveFiltersCount(countedFilters, params)}
      >
        <RangePickerFilter
          fromParam="created_at_from"
          toParam="created_at_to"
          placeholder={[t('billing.created'), t('billing.created')]}
        />

        <RangePickerFilter
          fromParam="due_date_from"
          toParam="due_date_to"
          placeholder={[t('billing.due_date'), t('billing.due_date')]}
        />

        <RangePickerFilter
          fromParam="pay_date_from"
          toParam="pay_date_to"
          placeholder={[t('billing.pay_date'), t('billing.pay_date')]}
        />
      </MoreFiltersPopover>
    </>
  )
}
